import { render, staticRenderFns } from "./AtomScrollUp.vue?vue&type=template&id=0b032f4e&scoped=true&"
import script from "./AtomScrollUp.vue?vue&type=script&lang=js&"
export * from "./AtomScrollUp.vue?vue&type=script&lang=js&"
import style0 from "./AtomScrollUp.vue?vue&type=style&index=0&id=0b032f4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b032f4e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
